const uuidPattern = /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
const exportToolPattern = /^(?:stories|sketches)$/i;
const colorHexPattern = /^#[0-9A-Z]{6}$/i;
export { colorHexPattern, exportToolPattern, uuidPattern };
//# sourceMappingURL=regex.js.map